import $ from 'jquery';
import 'mustache';
import Mustache from "mustache";
import Cleave from 'cleave.js';

const $industryButtons = $('.industries [data-industry]');
const $calculatorSection = $('#calculator-forms');
const $calculatorSectionTitle = $calculatorSection.find('.calculator-title');
const $calculatorSectionIndustryLabel = $calculatorSectionTitle.find('.industry');

const $calclulatorIndustryReset = $('[data-resetcalculator]');

const $calculators = $calculatorSection.find('.calculator');

const buttonTemplate = '<a class="button button--outline c--primary" href="{{url}}" target="_blank">{{title}}</a>';
const resultSingleTemplate = '<div class="result"><span class="result__title">{{name}}</span><span class="result__value">{{value}}</span></div>';

let currentIndustry = null;

function setupCalculators() {
    // Don't setup if we don't have the prerequisite data
    if(window['calculatordata'] === undefined)
        return;

    // Set up industry on button click.
    $industryButtons.click(function () {
        selectIndustry($(this).attr('data-industry'));
        $calculatorSection[0].scrollIntoView({
            behavior: 'smooth',
        });
    });

    $('.industries .industries-dropdown').change(function () {
        const industryID = $(this).val();
        const industry = calculatordata.find(ind => ind.id == industryID);

        if(industry.form === 'link') {
            window.location = industry.custom_link;
            return;
        }

        selectIndustry(industryID);
        $calculatorSection[0].scrollIntoView({
            behavior: 'smooth',
        });
    });

    // Set up industry on select change
    $calculators.find('select[name="industry"]').change(function () {
        selectIndustry($(this).val());
    });

    // Setup the calculator submission events
    $calculators.each(function () {
        const $self = $(this);

        const $submit = $self.find('.submit');
        const $resultsWrap = $self.find('.results');

        // Get all the number inputs
        const $numberInputs = $self.find('input[type="number"]');
        // We need to Change the number input types so we can add characters that aren't supported.
        $numberInputs.attr('type', 'text');

        // Format the input values
        $numberInputs.each(function () {
            const inputFilter = new Cleave(this, {
                numeral: true,
                numeralThousandsGroupStyle: 'thousand',
            });
        })

        $self.submit(function (event) {
            event.preventDefault();

            const data = $self.serializeArray();
            const calculatorMethod = window['calculate_' + $self.attr('id')];
            const $resultLinks = $resultsWrap.find('.results__links');
            const $resultCalculations = $resultsWrap.find('.results__calculations');

            $resultLinks.empty();

            // If we have an industry page defined, output the buttons linking to it here.
            if(currentIndustry['industry_page']['url']) {
                $resultLinks.append(Mustache.render(buttonTemplate, {
                    title: 'Buy Now',
                    url: currentIndustry['industry_page']['url'] + '#products',
                }));
            }

            // If we have a valid calculator method (defined below, ~ around line 170)
            if(typeof calculatorMethod === 'function') {
                // Calculation is expected to return an array with key value pairs.
                const results =  calculatorMethod.apply(null, [data]);

                if(results.length) {
                    $resultCalculations.empty();
                    // Build out the results from the calculation results
                    results.forEach(v => {
                        $resultCalculations.append( Mustache.render(resultSingleTemplate, v))
                    });
                }
            } else {
                console.warn('No calculator function for ' + $self.attr('id'));
            }

            $resultsWrap.addClass('active');
            $submit.prop('disabled', true);
        });

        $self.on('reset', function () {
            $(this).find('.field__info').text('');
            $resultsWrap.removeClass('active');
            $submit.prop('disabled', false);
        });
    });

    $calclulatorIndustryReset.click(function () {
        // Hide the reset button
        $calclulatorIndustryReset.prop('disabled', true);

        // Reset the forms
        $calculators.each(function () {
            const $self = $(this);
            $self[0].reset();
            $self.find('.field__info').empty();
            $self.find('.results').removeClass('active');
            $self.find('.submit').prop('disabled', false);
            enableForm($self);
        });

        // Clear the "Current Industry"
        currentIndustry = null;
        $calculatorSectionIndustryLabel.empty();

        // Set all the other industry dropdowns to our new value (the mobile industry selector)
        $('.industries-dropdown').val('');
    });
}

function selectIndustry(industryID) {
    currentIndustry = calculatordata.find(ind => ind.id == industryID);
    $calculatorSectionIndustryLabel.text(currentIndustry.title);

    $calclulatorIndustryReset.prop('disabled', false);

    // Get the current form and set the industry select field.
    const $currentIndustryForm = $calculators.filter('#' + currentIndustry.form);
    const $industryField = $currentIndustryForm.find('select[name="industry"]');
    $industryField.val(industryID);
    enableForm($currentIndustryForm);

    // Get the other forms, reset them and disable them.
    const $otherForms = $calculators.filter(':not(#'+ currentIndustry.form + ')');
    $otherForms.each(function () {
        disableForm($(this));
    });

    // Set all the other industry dropdowns to our new value (the mobile industry selector)
    $('.industries-dropdown').val(industryID);

    // Prefill the BOD field with the average value of that industry
    let bodValue = '';
    const $bodField = $currentIndustryForm.find('input[name="incoming_bod"]');

    if(currentIndustry['bod_min'] && currentIndustry['bod_max']) {
        bodValue = (Number(currentIndustry['bod_min']) + Number(currentIndustry['bod_max'])) / 2;
        $bodField.next('.field__info').text('BOD for ' + currentIndustry.title + ' range from ' + currentIndustry['bod_min'] + ' to ' + currentIndustry['bod_max'] + ' mg/L. Adjust this value as needed' );
    } else {
        $bodField.next('.field__info').text('');
    }

    // We aren't going to be outputting the average BOD value in the field, but this line does that in case we change our minds
    // $bodField.val(bodValue);
}

function disableForm($form) {
    $form[0].reset();
    $form.find('fieldset').prop('disabled', true);
    $form.find('.field__info').empty();
    $form.addClass('disabled');
}

function enableForm($form) {
    $form.find('fieldset, input, select').prop('disabled', false);
    $form.removeClass('disabled');
}

/**
 * Get Value from formdata array (output from $.serializeArray)
 * @param name Field Name
 * @param data Data array
 * @return {*}
 */
function getFormValue(name, data) {
    return data.find(property => property.name === name).value;
}

/**
 * Rounds a number off to the nth digit
 * @source https://stackoverflow.com/questions/15762768/javascript-math-round-to-two-decimal-places/15762794#answer-15762794
 * @param n The number to round
 * @param digits The number of digits
 * @return {number}
 */
function roundTo(n, digits) {
    if (digits === undefined) {
        digits = 0;
    }

    const multiplier = Math.pow(10, digits);
    n = parseFloat((n * multiplier).toFixed(11));
    const test =(Math.round(n) / multiplier);
    return +(test.toFixed(digits));
}

/**
 * Equation for BOD (lb/day) = (gal/day)*(3.8L/gal)*(BOD mg/L)*(1 lb/453592 mg)
 * @param incoming_bod
 * @param gallons_per_day
 * @return {number}
 */
function lb_BOD_per_day(incoming_bod, gallons_per_day ) {
    return incoming_bod * 3.78 * gallons_per_day / 453592;
}

/**
 * Outputs string with pounds and ounces
 * Example: for 1.5, will output "1 pound, 8 ounces"
 * @param num
 * @return {string}
 */
function float_to_lb_string (num) {
    const pounds = Math.floor(num);
    const ounces = pounds ? roundTo((num - pounds) * 16, 1) : roundTo((num - pounds) * 16, 2);
    return (pounds ? pounds + ' Pound' + (pounds !== 1 ? 's' : '') : '') + (pounds && ounces ? ', ' : '') + (ounces ? ounces + ' Ounce' + (ounces !== 1 ? 's' : '') : '') + (!pounds && !ounces ? '0.01 Ounces' : '');
}

const logCalculator = false;

function dosage_calculation(formdata, control_pounds_per_week) {
    const incoming_bod = parseFloat(getFormValue('incoming_bod', formdata).replace(/,/g, ''));
    const gallons_per_day = parseFloat(getFormValue('gallons_per_day', formdata).replace(/,/g, ''));

    const control_bod_per_day = lb_BOD_per_day(300, 750000);

    const pounds_of_bod_per_day = lb_BOD_per_day(incoming_bod, gallons_per_day);
    const ratio_of_lbs_bod_to_control =  pounds_of_bod_per_day / control_bod_per_day;
    const bacteria_strength_CFU_per_gram = control_pounds_per_week * ratio_of_lbs_bod_to_control;

    const initial_pounds_per_week = roundTo(bacteria_strength_CFU_per_gram, 4);

    // If Initial ppw is < .01, then multiply x3, else if ratio is over 1.5, then increase by 30%
    const pounds_per_week = initial_pounds_per_week < 0.01 ? initial_pounds_per_week * 3 : ( ratio_of_lbs_bod_to_control > 1.5 ? initial_pounds_per_week * 1.3 : initial_pounds_per_week);
    const pounds_per_day = roundTo(pounds_per_week / 5, 4);

    if (logCalculator) {
        console.clear();
        console.log('Incoming BOD', incoming_bod);
        console.log('Gallons Per Day', gallons_per_day);
        console.log('------------------------------------------------------------');
        console.log('Control Pounds of BOD Per Day', control_bod_per_day);
        console.log('Control Pounds per week', control_pounds_per_week);
        console.log('------------------------------------------------------------');
        console.log('Pounds of BOD Per Day', pounds_of_bod_per_day);
        console.log('Ratio of LBs BOD to Control', ratio_of_lbs_bod_to_control);
        console.log('Bacteria Strength CFU per Gram', bacteria_strength_CFU_per_gram);
        console.log('------------------------------------------------------------');
        console.log('Pounds Per Week', pounds_per_week);
        console.log('Pounds Per Day', pounds_per_day);
    }
    return [
        {
            name: 'Dosage Per 5 Day Week',
            value: float_to_lb_string(pounds_per_week),
        },
        {
            name: 'Dosage Per Day',
            value: float_to_lb_string(pounds_per_day),
        },
        {
            value: 'To boost the bacterial population, please double the dosing suggestion for the first two weeks of application. This dosing suggestion is based on industry averages and customer feedback. Every waste stream is different and the dosing should be monitored and calibrated.'
        },
        {
            name: 'First 2 Weeks Dosage Suggestion',
            value: float_to_lb_string(pounds_per_week * 2),
        },
        {
            name: 'First 2 Weeks Dosage Per Day Suggestion',
            value: float_to_lb_string(pounds_per_day * 2),
        },
    ];
}

/**
 * Form calculation functions. Naming convention is 'calculate_' + formName.
 *
 * @param formdata - The current form data object
 * @return the output of the calculations as an array of values.
 *
 * The reason we are declaring these methods inside the window object is so we can call them from their name (passed as a string)
 *
 */
// region Declare calculation methods
// 5B calculator with FOG
window.calculate_with_fog = function (formdata) {
    return dosage_calculation(formdata, 5);
}

// 10B Calculator without FOG
window.calculate_without_fog = function (formdata) {
    return dosage_calculation(formdata, 2.5);
}
// endregion Declare calculation methods

setupCalculators();
